import address from './address.json';
import asm from './asm.json';
import cart from './cart.json';
import checkout from './checkout.json';
import checkoutReview from './checkoutReview.json';
import common from './common.json';
import forms from './forms.json';
import internalServer from './internalServer.json';
import myAccount from './myAccount.json';
import myAccountV2Email from './myAccountV2Email.json';
import myAccountV2Order from './myAccountV2Order.json';
import myAccountV2Password from './myAccountV2Password.json';
import myAccountV2UserProfile from './myAccountV2UserProfile.json';
import myTickets from './myTickets.json';
import notifyme from './notifyme.json';
import order from './order.json';
import payment from './payment.json';
import product from './product.json';
import pwa from './pwa.json';
import savedCart from './savedCart.json';
import shipping from './shipping.json';
import storeFinder from './storeFinder.json';
import stores from './stores.json';
import user from './user.json';
import userAccount from './userAccount.json';
import userProfile from './userProfile.json';
import WebServiceIOError from './WebServiceIOError.json';

export const en = {
  address,
  asm,
  cart,
  checkout,
  checkoutReview,
  common,
  forms,
  internalServer,
  myAccount,
  myAccountV2Email,
  myAccountV2Order,
  myAccountV2Password,
  myAccountV2UserProfile,
  myTickets,
  notifyme,
  order,
  payment,
  product,
  pwa,
  savedCart,
  shipping,
  storeFinder,
  stores,
  userAccount,
  userProfile,
  WebServiceIOError,
  user
};
